import { Theme } from '@mui/material';
import { CbridgePalette } from '@cbridge-utils/mui-theme';

export const getSidePanelStyle = (theme: Theme, isLeft: boolean) => {
  return {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: CbridgePalette.background.sideBar,
    color: theme.palette.text.secondary,
    overflow: 'hidden',
    position: 'relative',
    ...(isLeft
      ? { borderRight: `1px solid ${theme.palette.divider}` }
      : { borderLeft: `1px solid ${theme.palette.divider}` }),
  };
};
